import { useContext, useState } from "react"
import Loader from "../Loader";
import SystemModal from "../SystemModal";
import SchoolContext from "../../../Context/SchoolContext";
import Select from "react-select";
import ajaxBank from "../../../util/remote/ajaxBank";


const TermlyFeesFilterForm=(props)=>{

    const [loading, setLoading] = useState(false)
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [query, setQuery] = useState("");

    const [term, setTerm] = useState("");

    const {schoolList, schoolTermList} = useContext(SchoolContext);
    const [school, setSchool] = useState("");

    const handleSearch = async(e) =>{
        e.preventDefault()
        setLoading(true)
        const server_response = await ajaxBank.searchTermlyFeeInvoices(props.page, query, startDate, endDate, term, school);
        setLoading(false);
        if(server_response.status==="OK"){
            props.h(server_response.details.meta.totalPages);
            props.g(server_response.details.data || []);
        }
        else{
            props.g([])
        } 
    }
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleSearch}>Filter<i class="fas fa-check mg-l-15"></i></button>
                    </>
        }
    }

    return(
        <SystemModal
            title="Filter Termly Fee Invoices"
            id="model-termly-fee-filter"
            size="md"
            footer={RenderFooter}
        >

            <div className="row">
                <div className="col-lg-12">
                    <div className="mb-4 form-group border-1">
                        <label htmlFor="">Student Name</label>
                        <input  onChange={(e) => setQuery(e.target.value)} placeholder="Enter student name..."  style={{border: "1px solid grey"}} value={query} type="text" className="form-control"/>
                    </div>
                </div>
               
            </div>
            <div className="row">
                <div className="col-lg-6">
                    <div className="mb-4 form-group border-1">
                <label htmlFor="">School</label>
                <Select
                      onChange={(e) => setSchool(e.school_id)}
                      getOptionLabel={(option) => option.school_name}
                      getOptionValue={(option) => option.school_id}
                      isSearchable
                      options={Array.isArray(schoolList) ? schoolList : []}
                      value={
                        Array.isArray(schoolList) &&
                        schoolList.find((value) => value.school_id === school)
                      }
                    />
            </div>
                </div>
                <div className="col-lg-6">
                    <div className="mb-4 form-group border-1">
                <label htmlFor="">School Term</label>

                    <Select
                      onChange={(e) => setTerm(e.term_id)}
                      getOptionLabel={(option) => option.term_name}
                      getOptionValue={(option) => option.term_id}
                      isSearchable
                      options={Array.isArray(schoolTermList) ? schoolTermList : []}
                      value={
                        Array.isArray(schoolTermList) &&
                        schoolTermList.find((value) => value.term_id === term)
                      }
                    />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6">
                    <div className="mb-4 form-group border-1">
                        <label htmlFor="">Start Date</label>
                        <input  onChange={(e) => setStartDate(e.target.value)}  style={{border: "1px solid grey"}} value={startDate} type="date" className="form-control"/>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="mb-4 form-group border-1">
                        <label htmlFor="">End Date</label>
                        <input onChange={(e) => setEndDate(e.target.value)}  style={{border: "1px solid grey"}} value={endDate} type="date" className="form-control"/>
                    </div>
                </div>
            </div>
        
       
        </SystemModal>
    )
}

export default TermlyFeesFilterForm
